export default "__VITE_ASSET__DewYvS8z__"